import { useEffect, useState } from "react";
import {
  getMenuButtonBoundingClientRect,
  getSystemInfoSync,
} from "@tarojs/taro";

const useCustomNavBar = () => {
  const [navInfo, setNavinfo] = useState({
    navBarHeight: 0,
    statusBar: 0,
    buttonRight: 0,
  });

  useEffect(() => {
    if (process.env.TARO_ENV !== "h5") {
      const { top, height, right } = getMenuButtonBoundingClientRect();

      const { statusBarHeight = 0, screenWidth } = getSystemInfoSync();

      const navBarHeight = height + (top - statusBarHeight) * 2;

      setNavinfo({
        navBarHeight,
        statusBar: statusBarHeight,
        buttonRight: screenWidth - right,
      });
    }
  }, []);

  return navInfo;
};

export default useCustomNavBar;
